// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"0e1252ae","220":"995e0865","255":"f113a1c4","411":"656ea0ef","497":"efd23467","560":"ebab47f9","724":"8c70878c","727":"28cfa19b"}[chunkId] + ".chunk.js";
};